import React, { useRef } from "react";
import CategoryCard from "./CategoryCard";
import { EC } from "../../utils/const/ecommerce-colors-const";
import { STRING_ID_ALL } from "../../utils/const/string-const";

export default function CategoryScroller({ categories, activeCategory, onCategoryChange }) {
    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (!scrollRef.current) return;
        const amount = direction === "left" ? -280 : 280;
        scrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
    };

    const scrollBtnClass = `absolute top-1/2 z-10 hidden h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition md:flex ${EC.category.scrollBtn}`;

    return (
        <div className="relative">
            <button
                type="button"
                onClick={() => scroll("left")}
                className={`${scrollBtnClass} -left-2 lg:-left-4`}
                aria-label="Scroll categories left"
            >
                ‹
            </button>
            <button
                type="button"
                onClick={() => scroll("right")}
                className={`${scrollBtnClass} -right-2 lg:-right-4`}
                aria-label="Scroll categories right"
            >
                ›
            </button>

            <div
                ref={scrollRef}
                className="flex gap-3 overflow-x-auto pb-2 scrollbar-thin scroll-smooth snap-x snap-mandatory sm:gap-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
            >
                {/* <CategoryCard
                    category={{ id: "all", icon: "🛒", image: "/images/ecommerce/categories/all.svg" }}
                    active={activeCategory === "all"}
                    onClick={() => onCategoryChange(STRING_ID_ALL)}
                /> */}
                {categories.map((category) => (
                    <div key={category.id} className="snap-start">
                        <CategoryCard
                            category={category}
                            active={activeCategory === category.id}
                            onClick={() => onCategoryChange(category)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
